import React, { useEffect, useState } from "react"
import { Button, Form, FormControl, Modal } from "react-bootstrap"
import { useSelector, useDispatch } from "react-redux";
import { fetchTenantEmployees, fetchTenants, fetchUsers } from "../app/actions";

const initialValue = {id: null, TenantID: "", UserID: "", TenantRole: "user", TenantEmployeeID: ""}

const AddEditUserTenantConnectionModal = ({tenant, user, editUserTenantConnection = null, show, onHide, onSave, onDelete}) => {
    const users = useSelector(store => store.app.users)
    const tenants = useSelector(store => store.app.tenants)
    const tenantEmployees = useSelector(store => store.app.tenantEmployees)
    const dispatch = useDispatch()
    const [userTenantConnection, setUserTenantConnection] = useState({
        ...initialValue,
        TenantID: tenant ? tenant : "",
        UserID: user ? user: ""
    })

    useEffect(()=>{
        dispatch(fetchUsers())
        dispatch(fetchTenants())
    }, [])
    
    useEffect(()=>{

        if(editUserTenantConnection) {
            setUserTenantConnection({
                id: editUserTenantConnection.id,
                TenantID: tenant ? tenant : (editUserTenantConnection.TenantID || ""),
                UserID: user ? user : (editUserTenantConnection.UserID || ""),
                TenantRole: editUserTenantConnection.TenantRole || "",
                TenantEmployeeID: editUserTenantConnection.TenantEmployeeID || ""
            })
        } else {
            setUserTenantConnection({
                ...initialValue,
                TenantID: tenant ? tenant : "",
                UserID: user ? user: ""
            })
        }
    }, [show])

    useEffect(()=>{
        if(tenants && userTenantConnection.TenantID) {
            const tenant = tenants.find(tenant => tenant.id === +userTenantConnection.TenantID)
            dispatch(fetchTenantEmployees(tenant.DB_NAME))
        }
    }, [userTenantConnection.TenantID, tenants])

    const handleSave = () => {
        onSave(userTenantConnection)
    }

    const handleDelete = () => {
        onDelete(userTenantConnection)
    }

    const handleChange = (e) => {
        setUserTenantConnection({
            ...userTenantConnection,
            [e.target.name]: e.target.value
        })
    }

    const handleRadioButtonChange = e => {
        setUserTenantConnection({
            ...userTenantConnection,
            [e.target.name]: e.target.value
        })
    }

    return <Modal show={show} onHide={onHide}>
        <Modal.Header>
            <Modal.Title>
                {editUserTenantConnection ? "Edit user tenant connection #" + editUserTenantConnection.id : "Create user tenant connection"}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
            {!user && <Form.Group>
                <Form.Label>User *</Form.Label>
                <Form.Control disabled={editUserTenantConnection} as="select" name="UserID" value={userTenantConnection.UserID} onChange={handleChange}>
                    <option value={""}>Pick user</option>
                    {users && users.map(user => <option key={user.id} value={user.id}>
                        #{user.id} {user.FirstName} {user.LastName}
                    </option>)}
                </Form.Control>
            </Form.Group>}
            {!tenant && <Form.Group>
                <Form.Label>Tenant *</Form.Label>
                <Form.Control disabled={editUserTenantConnection} as="select" name="TenantID" value={userTenantConnection.TenantID} onChange={handleChange}>
                    <option value={""}>Pick tenant</option>
                    {tenants && tenants.map(tenant => <option key={tenant.id} value={tenant.id}>
                        #{tenant.id} {tenant.FullName}
                    </option>)}
                </Form.Control>
            </Form.Group>}
            <Form.Group>
                <Form.Label>Tenant Role</Form.Label>
                <Form.Check
                    id="adminRadioOption"
                    type="radio"
                    name="TenantRole"
                    label="Admin"
                    value="admin"
                    checked={userTenantConnection.TenantRole === "admin"}
                    onChange={handleRadioButtonChange}
                />
                <Form.Check
                    id="userRadioOption"
                    type="radio"
                    name="TenantRole"
                    label="User"
                    value="user"
                    checked={userTenantConnection.TenantRole === "user"}
                    onChange={handleRadioButtonChange}
                />
            </Form.Group>
            <Form.Group>
                <Form.Label>
                    Tenant Employee *
                </Form.Label>
                <FormControl as="select" name="TenantEmployeeID" value={userTenantConnection.TenantEmployeeID} onChange={handleChange}>
                    <option value={""}>Pick employee</option>
                    {tenantEmployees && tenantEmployees.map(employee => {
                        return <option key={employee.id} value={employee.id}>
                            #{employee.id} {employee.first_name} {employee.last_name}
                        </option>
                    })}
                </FormControl>
            </Form.Group>
        </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="default" onClick={onHide}>Cancel</Button>
            {editUserTenantConnection && <Button onClick={handleDelete} variant="danger">Delete</Button>}
            <Button onClick={handleSave} disabled={!userTenantConnection.TenantEmployeeID || !userTenantConnection.UserID}>Save</Button>
        </Modal.Footer>
    </Modal>
}

export default AddEditUserTenantConnectionModal